#import "./lineInfo.gql"

mutation CreateLine($id: ID!, $name: String!, $lineType: String!, $efficiency: Float, $active: Boolean) {
  createLine(id: $id, name: $name, lineType: $lineType, efficiency: $efficiency, active: $active) {
    line {
      ...lineInfo
      plannedBreaks {
        ...plannedBreakInfo
      }
    }
  }
}

mutation UpdateLine($id: ID!, $name: String!, $lineType: String!, $efficiency: Float, $active: Boolean) {
  updateLine(id: $id, name: $name, lineType: $lineType, efficiency: $efficiency, active: $active) {
    line {
      ...lineInfo
      plannedBreaks {
        ...plannedBreakInfo
      }
    }
  }
}

query GetAllLines($activeOnly: Boolean) {
  lines(activeOnly: $activeOnly) {
    plannedBreaks {
      ...plannedBreakInfo
    }
    ...lineInfo
  }
}

mutation DeleteLine($id: ID!) {
  deleteLine(id: $id) {
    name
  }
}

mutation ReorderLines($lineOrder: [ID!]!) {
  reorderLines(lineOrder: $lineOrder) {
    lines {
      ...lineInfo
      plannedBreaks {
        ...plannedBreakInfo
      }
    }
  }
}
